import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { getIsPrescriptionUploadStepValid, getPrescriptionType } from '../../selectors.js';
import { PRESCRIPTION_FILE, NEW_PRESCRIPTION_AND_UPLOAD } from '../../../constants.js';
import { PrescriptionUploadStepContainer } from '../../../../steps/PrescriptionUploadStep/PrescriptionUploadStepContainer.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';

const prescriptionUploadStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionUploadStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionUploadStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === PRESCRIPTION_FILE || prescriptionType === NEW_PRESCRIPTION_AND_UPLOAD ? 'sub-step' : 'hidden'
    )
};

export { prescriptionUploadStepBase };
//# sourceMappingURL=prescription-upload.js.map
